// frontend/src/Constants.js

export const INVOICE = "invoice";
export const PO = "po";